'use client';

import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card';
import { PROGRAMS } from '@/lib/constants';
import Link from 'next/link';
import { ArrowRight } from 'lucide-react';

export function Programs() {
  return (
    <section id="programs" className="bg-secondary">
      <div className="container mx-auto px-4">
        <div className="text-center space-y-4 mb-12">
          <h2 className="text-3xl md:text-4xl font-bold font-headline">Our Programs</h2>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
            A diverse range of courses designed to foster holistic brain development for every age group.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {PROGRAMS.map((program) => (
            <div key={program.slug} className="h-full">
                <Card className="flex flex-col group overflow-hidden shadow-lg h-full border-primary/10 bg-white/50 backdrop-blur-sm hover:bg-white/80 transition-all duration-300">
                <CardHeader>
                    <div className="flex items-center gap-4">
                    <div className="bg-primary/10 p-3 rounded-lg group-hover:scale-110 transition-transform">
                        <program.icon className="w-8 h-8 text-primary" />
                    </div>
                    <div>
                        <CardTitle className="font-headline text-xl">{program.title}</CardTitle>
                        <CardDescription className="font-semibold text-primary">Ages: {program.ageGroup}</CardDescription>
                    </div>
                    </div>
                </CardHeader>
                <CardContent className="flex-grow">
                    <p className="text-muted-foreground text-sm leading-relaxed">{program.description}</p>
                </CardContent>
                <CardFooter>
                    <Button asChild variant="ghost" className="w-full justify-between hover:bg-primary hover:text-white group">
                    <Link href={`/programs/${program.slug}`}>
                        Learn More
                        <ArrowRight className="w-4 h-4 transform group-hover:translate-x-1 transition-transform" />
                    </Link>
                    </Button>
                </CardFooter>
                </Card>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
